export const environment = {
  production: false,
  rememberMeKey: '2_cfs_32sad_s',
  guest_url: 'https://api.dubaiownersclub.com/api/v1/guest/',
  base_url: 'https://api-dev.dubaiownersclub.com/api/v1/user/',
  socket_url: 'https://api-dev.dubaiownersclub.com',
  image_url: 'https://api-dev.dubaiownersclub.com/api/v1/Upload/uploadFile',
  // base_url: 'http://localhost:6888/api/v1/user/',
  // socket_url: 'http://localhost:6888',
  // image_url: 'http://localhost:6888/api/v1/Upload/uploadFile',
  // guest_url: 'http://localhost:6888/api/v1/guest/',
  storageKey: 'RE_EST_WEB_DEV-',
  redirectUrl: 'https://staging1.digikats.com/home/',
  redirectKey: 'RED_STOR_WEB_DEV-',
  googleKey: '',
  firebaseConfig: {
    apiKey: 'AIzaSyDvTc_nQlg64WKH-H742ftxEw7Uc6lXhS4',
    authDomain: 'ownrsclb-production-39b74.firebaseapp.com',
    projectId: 'ownrsclb-production-39b74',
    storageBucket: 'ownrsclb-production-39b74.firebasestorage.app',
    messagingSenderId: '220462962640',
    appId: '1:220462962640:web:0b56648982dd808b51cbd5'
  },
  path: '/firebase-messaging-sw.js',
  scope: '/'
} as const;
